import React from 'react';
import { IconButton } from '@mui/material';
import { Info as InfoIcon, Close as CloseIcon } from '@mui/icons-material';

import { ReactComponent as CashWalletFreezeIcon } from '@/img/icons/cash-wallet-freeze-icon.svg';

const BANNER_VARIANT = {
    FROZEN: 'frozen',
    ERROR: 'error',
};

const CashWalletBanner = ({ variant, message, onDismiss }) => {
    if (!variant || !message) {
        return null;
    }

    const isError = variant === BANNER_VARIANT.ERROR;
    const isFrozen = variant === BANNER_VARIANT.FROZEN;

    return (
        <div className={`cash-wallet-banner cash-wallet-banner-${variant}`}>
            <span className="cash-wallet-banner-icon">
                {isFrozen ? (
                    <span className="cash-wallet-banner-icon-freeze">
                        <CashWalletFreezeIcon className="cash-wallet-banner-icon-freeze-glyph" />
                    </span>
                ) : (
                    <InfoIcon fontSize="small" />
                )}
            </span>
            <span className="cash-wallet-banner-message">{message}</span>
            {isError && onDismiss && (
                <IconButton
                    className="cash-wallet-banner-close"
                    size="small"
                    aria-label="dismiss"
                    onClick={onDismiss}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        </div>
    );
};

CashWalletBanner.VARIANT = BANNER_VARIANT;

export default CashWalletBanner;
